import styled from 'styled-components';

import { CARD_RATIO } from '~/src/common/components/GridCard/layout';
import Icon from '~/src/common/components/Icon';
import Link from '~/src/common/components/Link';
import { H4 } from '~/src/common/components/Typography';
import { transparentize } from '~/src/common/utils/style';

export const Root = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const Title = styled(H4)`
  margin: 0;
`;

export const ViewAllLink = styled(Link)`
  color: ${({ theme }) => theme.palette.primary};
  font-size: 14px;
  font-weight: 500;
`;

export const SeeAllContainer = styled(Link)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  aspect-ratio: ${CARD_RATIO};

  width: 100%;
  height: 100%;
  padding: 8px;
  background-color: ${({ theme }) => theme.palette.common.DARK_LABEL};
  border-radius: 8px;
  cursor: pointer;
  box-shadow: ${({ theme }) => transparentize(theme.palette.common.BLACK_PURE, 0.25)} 0 2px 8px 0;
`;

export const SeeAllMainContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
`;

export const SeeAllMessage = styled.p`
  color: ${({ theme }) => theme.palette.common.WHITE};
  font-size: 18px;
  font-family: ${({ theme }) => theme.fonts.quaternary};
  font-weight: 700;
  text-align: center;
  margin: 0;
  max-width: 134px;
  text-transform: uppercase;
`;

export const SeeAllArrowIcon = styled(Icon)`
  color: ${({ theme }) => theme.palette.common.WHITE};
`;

export const SeeAllButton = styled.div`
  background-color: ${({ theme }) => theme.palette.primary};
  color: ${({ theme }) => theme.palette.common.WHITE};
  border-radius: 8px;
  padding: 8px 24px;
  font-size: 16px;
  font-weight: 500;
  text-align: center;
  margin-top: auto;
`;
